import * as React from "react";
import { OnSwitchingCallbackTypeDescriptor } from "react-swipeable-views";
import { SettingsWindowMobile } from "../../../../ui/SettingsWindowMobile";
import { SettingsWindowTitle } from "../../../../ui/SettingsWindowMobileTitle";
import { SettingsWindowsCloseButtonMobile } from "../../../../ui/SettingsWindowsCloseButtonMobile";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { Settings } from "../../AutoplayBetSettings/Mobile/components/Settings";
import { SettingsContent } from "../../AutoplayBetSettings/Mobile/components/SettingsContent";
import {
  AutoplayRoundsContainer,
  AutoplaySettingsContainer,
  SlideContainer,
  SlideTitle
} from "../../AutoplayBetSettings/Mobile/components/Slide";
import { AutoplayAdvancedMobile } from "./AutoplayAdvancedMobile";
import { IAutoplaySettingsMobile } from "./AutoplaySettingsMobile";
import { Setting } from "./components/Setting";

enum Pages {
  ROUNDS = 0,
  SETTINGS = 1
}

const setSlideIndexToRounds = () => ({ slideIndex: Pages.ROUNDS });
const setSlideIndexToSettings = () => ({ slideIndex: Pages.SETTINGS });

export class AutoplaySettingsMobileDefaultView extends React.PureComponent<
  IAutoplaySettingsMobile,
  any
> {
  public state = {
    slideIndex: Pages.ROUNDS
  };

  constructor(props: IAutoplaySettingsMobile) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    // define the sliderIndex based on the rounds selected and the required fields
    const notNull = x => x !== null;
    const { roundsSelected } = nextProps;
    const getSlideIndex = (currentSlideIndex, rounds) => {
      if (currentSlideIndex === Pages.SETTINGS && notNull(rounds)) {
        return Pages.SETTINGS;
      } else if (notNull(rounds)) {
        return Pages.SETTINGS;
      }

      return Pages.ROUNDS;
    };

    this.setState({
      slideIndex: getSlideIndex(this.state.slideIndex, roundsSelected)
    });
  }

  public onSwitching = (type: OnSwitchingCallbackTypeDescriptor) => {
    // on mobile swipe, ROUNDS and SETTINGS page should update the next/prev icon accordingly
    if (type === "end") {
      if (this.state.slideIndex === Pages.ROUNDS) {
        this.setState(setSlideIndexToSettings());
      } else {
        this.setState(setSlideIndexToRounds());
      }
    }
  };

  public previousOnClick = () => {
    this.setState(setSlideIndexToRounds());
  };

  public nextOnClick = () => {
    this.setState(setSlideIndexToSettings());
  };

  public render() {
    const {
      available,
      isOpen,
      onClose,
      roundsSelected,
      availableRounds,
      allowAutoplayStart,
      settings,
      triggerAutoplayRoundsChangeRequest,
      triggerAutoplaySettingChangeRequest,
      triggerAutoplaySettingsResetRequest,
      t
    } = this.props;

    const { slideIndex: index } = this.state;
    const hasRoundSelected = roundsSelected !== null;

    // redefine the callbacks based on the slideIndex and rounds
    const isRoundsPage = idx => idx === Pages.ROUNDS;
    const previousOnClick = isRoundsPage(index) ? null : this.previousOnClick;
    const nextOnClick =
      !isRoundsPage(index) || !hasRoundSelected ? null : this.nextOnClick;

    if (!isOpen) {
      return null;
    }

    return (
      <SettingsWindowMobile open={isOpen}>
        {available && (
          <SettingsContent>
            <SlideContainer
              disabled={!hasRoundSelected}
              index={index}
              onSwitching={this.onSwitching}
            >
              <AutoplayRoundsContainer
                data-e2e-id={E2EIdentifier.AUTOPLAY_ROUNDS_CONTAINER}
              >
                <SettingsWindowTitle dataE2EId={E2EIdentifier.AUTOPLAY_TITLE}>
                  {t("AutoplayTitle")}
                </SettingsWindowTitle>
                <SlideTitle
                  data-e2e-id={E2EIdentifier.AUTOPLAY_ROUNDS_SUBTITLE}
                >
                  {t("AutoplaySubTitle")}
                </SlideTitle>
                <Settings
                  data-e2e-id={E2EIdentifier.AUTOPLAY_ROUNDS_LIST_CONTAINER}
                >
                  {availableRounds.map((value, index) => {
                    const active = value === roundsSelected;
                    const onClick = () =>
                      triggerAutoplayRoundsChangeRequest(value);

                    return (
                      <Setting
                        key={index}
                        label={value.toString()}
                        data-value={value}
                        active={active}
                        disabled={false}
                        onClick={onClick}
                        data-e2e-id={`${E2EIdentifier.AUTOPLAY_ROUNDS_BUTTON}-${value}`}
                        requiredText={t("Required")}
                      />
                    );
                  })}
                </Settings>
              </AutoplayRoundsContainer>
              <AutoplaySettingsContainer
                data-e2e-id={E2EIdentifier.AUTOPLAY_SETTINGS_CONTAINER}
              >
                <SettingsWindowTitle dataE2EId={E2EIdentifier.AUTOPLAY_TITLE}>
                  {t("AutoplayTitle")}
                </SettingsWindowTitle>
                <SlideTitle
                  data-e2e-id={E2EIdentifier.AUTOPLAY_SETTINGS_SUBTITLE}
                >
                  {t("AutoplaySettingsSubTitle")}
                </SlideTitle>
                <AutoplayAdvancedMobile
                  settings={settings}
                  disabled={!roundsSelected}
                  onChange={triggerAutoplaySettingChangeRequest}
                  onReset={triggerAutoplaySettingsResetRequest}
                  resetButtonLabel={t("Reset")}
                  requiredText={t("Required")}
                />
              </AutoplaySettingsContainer>
            </SlideContainer>
          </SettingsContent>
        )}
        <SettingsWindowsCloseButtonMobile
          onClose={onClose}
          allowAutoplayStart={allowAutoplayStart}
          autoplayButtonVisible={true}
          previousOnClick={previousOnClick}
          nextOnClick={nextOnClick}
        />
      </SettingsWindowMobile>
    );
  }
}
